// ANGEL FLIGHT — shared procedural noise buffer.
//
// One white-noise buffer is baked ONCE per AudioContext and reused by every
// transient (gunshots fire ~15-20×/sec — re-filling a Float32Array each shot
// would thrash the GC). Callers wrap it in a throwaway BufferSource, pick a
// random start offset for variety, and stop+disconnect it on end.

/** Bake a mono white-noise buffer of `seconds` length, sample-rate matched. */
export function makeNoiseBuffer(ctx: BaseAudioContext, seconds = 1): AudioBuffer {
  const len = Math.max(1, Math.floor(ctx.sampleRate * seconds));
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < len; i++) data[i] = Math.random() * 2 - 1;
  return buf;
}
